module.exports = __webpack_public_path__ + "static/media/Prenton Chetty.947bab43.jpg";